import React from "react"
import Card from "components/Card"
import * as css from "./Customer.module.css"

function Customer({ url, title, logo }) {
  return (
    <Card className={css.root} href={url} target="_blank">
      <img
        src={logo.url}
        alt={title}
        style={{ width: "100%", display: "block" }}
      />
    </Card>
  )
}

export default Customer
